import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { GenericSharedModule } from '../../../generics/generic-shared.module';
import { ModalPasswordComponent } from './modal-password/modal-password.component';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  imports: [RouterModule, CommonModule, GenericSharedModule,ReactiveFormsModule],
  declarations: [ NavbarComponent, ModalPasswordComponent ],
  exports: [ NavbarComponent ]
})

export class NavbarModule {}
